<template>
  <div class="shoppe">
    <el-row :gutter="15">
      <el-col :sm="24" :md="12" :lg="8" :xl="8" class="mb20" v-for="(item, index) in YesterdayList" :key="index">
        <div class="chart-container" :ref="'chart-yesterday-' + index"></div>
      </el-col>
    </el-row>
    <div class="header">
      报表：
      <el-select style="width: 200px" v-model="boutiqueListenerGroupId" placeholder="请选择报表" @change="getColumnList">
        <el-option v-for="item in groupList" :key="item.boutiqueListenerGroupId" :label="item.listenerName" :value="item.boutiqueListenerGroupId"></el-option>
      </el-select>
      <span class="ml20">时间：</span>
      <el-date-picker
        v-model="daterange"
        @change="changeColumnList"
        type="daterange"
        value-format="timestamp"
        :picker-options="pickerOptions"
        :clearable="false"
        :default-time="['00:00:00', '23:59:59']"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 250px">
      </el-date-picker>
      <span class="ml20">店铺：</span>
      <el-select v-model="queryForm.businessId" filterable clearable placeholder="请选择" style="width: 200px" @change="changeColumnList">
        <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
      </el-select>
    </div>

    <div class="field-list">
      <span class="label">字段：</span>
      <div class="right">
        <el-checkbox-group v-model="columnList" @change="changeColumnList">
          <el-checkbox v-for="item in columnData" :label="item.eventType" :key="item.eventType">{{ item.eventName }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <el-table :data="tableData" @sort-change="sortChange" v-loading="loading">
      <el-table-column prop="businessName" label="店铺"></el-table-column>
      <el-table-column
        v-for="col in columnList"
        :key="col"
        :prop="col"
        :label="columnMap[col]"
        sortable="custom"
      ></el-table-column>
      <el-table-column label="操作" v-if="columnList.length > 0">
        <template slot-scope="scope">
          <span class="link-btn" @click="gotoDetail(scope.row)">查看明细</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="tr mt10"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getGroupList, getColumnList, getStatistics } from "./api";
import {
  getVendorList,
} from '@/views/buyershop/api';

function getStartDate(days) {
  const date = new Date();
  days = days || 0;
  date.setDate(date.getDate() + days);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return date;
}

function getEndDate(days) {
  const date = new Date();
  days = days || 0;
  date.setDate(date.getDate() + days);
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return date;
}

export default {
  data() {
    return {
      groupList: [],
      boutiqueListenerGroupId: null,
      daterange: [getStartDate(-2).getTime(), getEndDate().getTime()],
      vendorList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', [getStartDate(0), getEndDate()]);
          }
        }, {
          text: '3天',
          onClick(picker) {
            picker.$emit('pick', [getStartDate(-2), getEndDate()]);
          }
        }, {
          text: '7天',
          onClick(picker) {
            picker.$emit('pick', [getStartDate(-6), getEndDate()]);
          }
        }, {
          text: '1个月',
          onClick(picker) {
            picker.$emit('pick', [getStartDate(-29), getEndDate()]);
          }
        }]
      },
      loading: false,
      queryForm: {
        businessId: null,
        pageNo: 1,
        pageSize: 10,
        orderBy: null,
        orderDesc: null,
      },
      columnData: [],
      columnList: [],
      columnMap: {},
      tableData: [],
      total: 0,
      YesterdayList: [{
        title: '昨日全量商品失败统计TOP5',
        queryForm: {
          boutiqueListenerGroupId: 5,
          eventTypeList: ['product_all_update_failed'],
          orderBy: 'product_all_update_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }, {
        title: '昨日增量商品失败统计TOP5',
        queryForm: {
          boutiqueListenerGroupId: 5,
          eventTypeList: ['product_delta_update_failed'],
          orderBy: 'product_delta_update_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }, {
        title: '昨日全量库存失败TOP5',
        queryForm: {
          boutiqueListenerGroupId: 5,
          eventTypeList: ['stock_all_update_failed'],
          orderBy: 'stock_all_update_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }, {
        title: '昨日库存增量失败TOP5',
        queryForm: {
          boutiqueListenerGroupId: 5,
          eventTypeList: ['stock_delta_update_failed'],
          orderBy: 'stock_delta_update_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }, {
        title: '昨日下单失败TOP5',
        queryForm: {
          boutiqueListenerGroupId: 4,
          eventTypeList: ['boutique_created_order_failed'],
          orderBy: 'boutique_created_order_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }, {
        title: '昨日发送邮件失败TOP5',
        queryForm: {
          boutiqueListenerGroupId: 4,
          eventTypeList: ['boutique_send_email_failed'],
          orderBy: 'boutique_send_email_failed',
          orderDesc: true,
          pageSize: 5,
        }
      }]
    };
  },
  mounted() {
    window.addEventListener('resize', this.pageResize);
    this.initYesterday();
    getGroupList().then(res => {
      if (res.data.data) {
        this.groupList = res.data.data;
        this.boutiqueListenerGroupId = res.data.data[0].boutiqueListenerGroupId;
        this.getColumnList();
      }
    })
    getVendorList().then(res => {
      this.vendorList = res.data.data || [];
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageResize);
    this.YesterdayList.forEach((item, cindex) => {
      if (this['chart-yesterday-'+cindex]) {
        this['chart-yesterday-'+cindex].dispose();
        this['chart-yesterday-'+cindex] = null;
      }
    })
  },
  methods: {
    pageResize() {
      this.YesterdayList.forEach((item, cindex) => {
        if (this['chart-yesterday-'+cindex]) {
          this['chart-yesterday-'+cindex].resize();
        }
      })
    },
    parseStatistics(list) {
      const result = {};
      list.forEach((item) => {
        result[item.eventType] = item.total;
      });
      return result;
    },
    getColumnList() {
      getColumnList({
        boutiqueListenerGroupId: this.boutiqueListenerGroupId,
      }).then(res => {
        if (res.data.data) {
          this.columnData = res.data.data;
          this.columnList = res.data.data.slice(0, 4).map(item => item.eventType);
          this.columnData.forEach(item => {
            this.columnMap[item.eventType] = item.eventName;
          })
          this.queryForm.pageNo = 1;
          this.queryForm.orderBy = null;
          this.queryForm.orderDesc = null;
          this.getTableData();
        }
      });
    },
    changeColumnList() {
      if (this.columnList.length === 0) {
        this.$message('至少选择一个字段');
        return;
      }
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      if (this.columnList.length === 0) {
        this.$message('至少选择一个字段');
        return;
      }
      getStatistics({
        boutiqueListenerGroupId: this.boutiqueListenerGroupId,
        eventTypeList: this.columnList,
        ...this.queryForm,
        startTime: this.daterange[0],
        endTime: this.daterange[1],
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.list.map((item) => {
            return {
              businessId: item.businessId,
              businessName: item.businessName,
              ...this.parseStatistics(item.listenerDataStatisticsResVOList),
              show: false,
            };
          });
          this.total = res.data.data.total;
        }
      });
    },
    sortChange({ prop, order }) {
      if (order) {
        this.queryForm.orderBy = prop;
        this.queryForm.orderDesc = order === "descending";
      } else {
        this.queryForm.orderBy = null;
        this.queryForm.orderDesc = null;
      }
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    gotoDetail(row) {
      this.$router.push({
        path: `/dataMonitoring/detail?id=${this.boutiqueListenerGroupId}&businessId=${row.businessId}&startTime=${this.daterange[0]}&endTime=${this.daterange[1]}&columnList=${this.columnList.join(',')}`
      });
    },
    initYesterday() {
      this.YesterdayList.forEach((chart, cindex) => {
        this['chart-yesterday-'+cindex] = echarts.init(this.$refs['chart-yesterday-'+cindex][0]);
        getStatistics({
          ...chart.queryForm,
          pageNo: 1,
          startTime: getStartDate(-1).getTime(),
          endTime: getEndDate(-1).getTime(),
        }).then((res) => {
          if (res.data.success) {
            const data = res.data.data.list.reverse();
            const labelList = [];
            data.forEach((item, index) => {
              labelList.push(item.businessName);
            })
            const series = {
              name: chart.title,
              type: 'bar',
              data: data.map(d => d.listenerDataStatisticsResVOList[0].total),
              label: {
                show: true,
                position: 'right'
              },
            };
            this['chart-yesterday-'+cindex].setOption({
              title: {
                text: chart.title,
                left: '25%',
                textStyle: {
                  fontSize: 14
                }
              },
              grid: {
                top: 40,
                left: '25%',
                right: '8%',
                bottom: 30,
              },
              tooltip: {
                trigger: "axis",
              },
              // legend: {
              //   data: [chart.title],
              // },
              xAxis: {
                type: 'value',
                name: "次数",
              },
              yAxis: {
                type: 'category',
                data: labelList,
              },
              series: series,
            });
          }
        });
      })
    },
  },
};
</script>

<style lang="less" scoped>
.tr{
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.ml20 {
  margin-left: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.shoppe {
  padding: 15px 15px 40px;
}
.header {
  margin-top: 30px;
}

.module-title {
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
}
.link-btn {
  color: #409eff;
  cursor: pointer;
}
.chart-container {
  height: 300px;
}
.field-list {
  display: flex;
  margin-top: 20px;

  .right {
    flex: 1;
  }
}
</style>
